// stahlia-frontend/src/lib/migration-worklist.ts
// FE-Spiegel der Anzeige-Helfer zu src/modules/warehouse/migration-logic.ts — die Backend-
// Statusmaschine (aggregateProgress, nextWorklistStatus) bleibt alleinige Quelle der Wahrheit.
// Hier NUR reine Formatierungs-/Farb-Helfer fuer die Erstaufnahme-UI, keine Neu-Logik.
import type { MigrationTotals } from '@/api/warehouseMigration'

/** Gesamtfortschritt in Prozent: aufgenommen/leer/abweichung gelten als "Endzustand erreicht"
 *  (Spec §5) — nur `offen` ist noch zu tun. */
export function progressPercent(totals: MigrationTotals): number {
  if (totals.total === 0) return 0
  const done = totals.aufgenommen + totals.leer + totals.abweichung
  return Math.round((done / totals.total) * 100)
}

export type RowStatusColor = 'green' | 'amber' | 'zinc'

/** Ampelfarbe je Regalreihe fuer das Board: gruen = komplett (0 offen, Spec §5 "Regal-Abschluss"),
 *  zinc = noch nicht begonnen, amber = in Arbeit. */
export function rowStatusColor(complete: boolean, offen: number, total: number): RowStatusColor {
  if (complete) return 'green'
  if (total > 0 && offen === total) return 'zinc'
  return 'amber'
}

export function rowStatusLabel(color: RowStatusColor): string {
  if (color === 'green') return 'fertig'
  if (color === 'amber') return 'in Arbeit'
  return 'offen'
}

/**
 * Ermittelt die Lager-Zugehörigkeit (Halle 1 vs. Halle 2) anhand des Regal-Codes:
 * - Lager 1: R01 bis R21 (Halle 1)
 * - Lager 2: R22 bis R32 (Halle 2)
 * - null: unbekanntes Format
 */
export function getLagerForRow(rowCode: string): 1 | 2 | null {
  const m = rowCode.trim().toUpperCase().match(/^R(\d+)$/)
  if (!m || !m[1]) return null
  const n = parseInt(m[1], 10)
  if (n >= 1 && n <= 21) return 1
  if (n >= 22 && n <= 32) return 2
  return null
}

